<template>
    <div>

        <ControlPanel :card="false" :icon="'mdi mdi-format-list-bulleted'" :title="'Формирование SWIFT файлов'"
                      :links="links" :premium="true">
            <template v-slot:left>
                <SelectOrg :title="['Организация', 'Организация']" :name="'orgs'"
                           :table="'reg_organizations'"
                           :fields="['name']"></SelectOrg>
            </template>

            <b-button size="sm" variant="primary" :disabled="disabled.doswift" class="mr-1" @click="doSWIFT()"><span
                    class="mdi mdi-format-list-bulleted"></span> Сформировать SWIFT
            </b-button>
            <a class="btn btn-secondary btn-sm" :href="swift" target="_blank" v-if="!disabled.download"><span
                    class="mdi mdi-download"></span> Скачать SWIFT</a>
        </ControlPanel>

        <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">
            <div class="row">
                <div class="col-4">
                    <b-card header-bg-variant="secondary" header-text-variant="white" header="Параметры"
                            body-class="bg-green-light" class="border-0 mb-1">
                        <div class="row">
                            <div class="col-12">

                                <b-form-group>
                                    <b-input-group size="sm" prepend="Период">
                                        <Enums :type="'enum'" :name="'months'" v-model="period.month"></Enums>
                                        <Enums :type="'enum'" :name="'years'" v-model="period.year"></Enums>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group>
                                    <b-form-select size="sm" :options="options" v-model="params.mode"></b-form-select>
                                </b-form-group>


                            </div>

                            <div class="col-6">
                                <b-form-group>
                                    <b-input-group size="sm" prepend="№ плат.пор.">
                                        <b-form-input type="number" size="sm" v-model="params.number"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col-6">
                                <!--<b-form-group>
                                    <b-input-group size="sm" prepend="КНП">
                                        <b-form-input type="number" size="sm" v-model="params.knp"></b-form-input>
                                    </b-input-group>
                                </b-form-group>-->
                            </div>
                        </div>

                        <template v-if="params.mode == 'worker'">
                            <hr>
                            <h5>Реквизиты банка</h5>
                            <div class="row">
                                <div class="col-12">
                                    <b-form-group>
                                        <b-input-group size="sm" prepend="Наименование">
                                            <b-form-input size="sm" v-model="params.bank.name_full"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group>
                                        <b-input-group size="sm" prepend="БИН">
                                            <b-form-input size="sm" v-model="params.bank.bin"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group>
                                        <b-input-group size="sm" prepend="Счет поступления">
                                            <b-form-input size="sm" v-model="org.iik_salary"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>

                                </div>
                            </div>

                        </template>
                        <hr>
                        <h5>Реквизиты организации</h5>

                        <div class="row">
                            <div class="col-12">
                                <b-form-group>
                                    <b-input-group size="sm" prepend="Наименование">
                                        <b-form-input size="sm" v-model="org.name"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group>
                                    <b-input-group size="sm" prepend="ИИН/БИН">
                                        <b-form-input size="sm" v-model="org.iinbin"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group>
                                    <b-input-group size="sm" prepend="ИИК">
                                        <b-form-input size="sm" v-model="org.iik"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group>
                                    <b-input-group size="sm" prepend="БИК">
                                        <b-form-input size="sm" v-model="params.bank.bik"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                            </div>
                            <div class="col-7">

                            </div>
                            <div class="col-5">

                            </div>
                            <div class="col-12">
                                <b-form-group>
                                    <b-input-group size="sm" prepend="Руководитель">
                                        <b-form-input size="sm" v-model="org.chief"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group>
                                    <b-input-group size="sm" prepend="Гл.бухгалтер">
                                        <b-form-input size="sm" v-model="org.accountant"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                            </div>

                            <div class="col-6">
                                <b-form-group>
                                    <b-input-group size="sm" prepend="КБе">
                                        <b-form-input size="sm" v-model="org.kbe"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col-6">

                            </div>
                        </div>

                        <div style="font-size: 12px" class="text-danger"><strong>Примечание:</strong> Для того: чтобы
                            реквизиты организации заполнялись автоматически, заполните их в справочнике организаций.
                        </div>
                    </b-card>

                </div>
                <div class="col-8">
                    <b-card header-bg-variant="secondary" header-text-variant="white" header="Список сотрудников"
                            body-class="bg-light" class="border-0 mb-1">
                        <template v-if="userdata.length == 0">
                            Данные по сотрудникам за период не загружены. Убедитесь, что вы выбрали верный период для
                            формирования SWIFT и что за этот период у вас есть сохраненные расчеты заработной платы.
                        </template>
                        <template v-else>
                            <table class="table table-sm table-bordered table-hover">
                                <tbody>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Фамилия</th>
                                    <th>Имя</th>
                                    <th>Отчество</th>
                                    <th>ИИН</th>
                                    <th v-if="params.mode =='worker'">Карт-счет</th>
                                    <th>Дата рождения</th>
                                    <th>Сумма</th>
                                </tr>
                                <template v-for="(item, index) in userdata">
                                    <tr :key="index">
                                        <template v-if="Number(item.selected) == 1">
                                            <td>
                                                <b-form-checkbox size="sm" v-model="item.selected" value="1"
                                                                 unchecked-value="0"></b-form-checkbox>
                                            </td>
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                <b-form-input type="text" size="sm"
                                                              v-model="item.last_name"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm"
                                                              v-model="item.first_name"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm"
                                                              v-model="item.middle_name"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.iin"></b-form-input>
                                            </td>
                                            <td v-if="params.mode =='worker'">
                                                <b-form-input type="text" size="sm" v-model="item.iik"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="date" size="sm"
                                                              v-model="item.birthday"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.value"></b-form-input>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td>
                                                <b-form-checkbox size="sm" v-model="item.selected" value="1"
                                                                 unchecked-value="0"></b-form-checkbox>
                                            </td>
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.last_name"
                                                              disabled></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.first_name"
                                                              disabled></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.middle_name"
                                                              disabled></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.iin"
                                                              disabled></b-form-input>
                                            </td>
                                            <td v-if="params.mode =='worker'">
                                                <b-form-input type="text" size="sm" v-model="item.iik"></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="date" size="sm" v-model="item.birthday"
                                                              disabled></b-form-input>
                                            </td>
                                            <td>
                                                <b-form-input type="text" size="sm" v-model="item.value"
                                                              disabled></b-form-input>
                                            </td>
                                        </template>

                                    </tr>
                                </template>
                                <tr class="bg-light">
                                    <td colspan="8" class="text-right"><strong>СУММА:</strong>
                                        {{ formatMoney(getAmountField(userdata, 'value')) }} тенге,
                                        <strong>СОТРУДНИКОВ:</strong> {{ getSelectedRows(userdata) }}
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </template>
                    </b-card>
                </div>

            </div>

        </div>

        <Premium v-else/>

    </div>

</template>


<script>
import ControlPanel from "@/components/base/ControlPanel";
import SelectOrg from "@/components/base/SelectOrg";
import Enums from "@/components/base/Enums";
import Premium from "@/components/base/Premium"
import {mapGetters} from "vuex";

export default {
    name: 'BankSwift',
    components: {
        ControlPanel, SelectOrg, Enums, Premium
    },
    data: function () {
        return {
            links: [
                {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
            ],
            options: [
                {text: 'Перечисление зарплаты в банк', value: 'worker'},
                {text: 'Обязательные пенсионные взносы', value: 'opv'},
                {text: 'Обязательные пенсионные взносы работодателя', value: 'opvr'},
                {text: 'Социальные отчисления', value: 'so'},
                {text: 'Отчисления ОСМС', value: 'oosms'},
                {text: 'Взносы ОСМС', value: 'vosms'},
            ],
            params: {
                mode: 'worker',
                number: '',
                bank: {
                  name_full: '',
                  bin: '',
                  bik: '',
                },
                knp: '122'
            },
            period: {
                year: new Date().getFullYear(),
                month: '0'
            },
            disabled: {
                doswift: true,
                download: true
            },
            messages: [],
            userdata: [],
            swift: '',
            tooltip: ''
        }
    },
    methods: {
        downloadSWIFT: function () {
            var link = document.createElement('a');
            link.setAttribute('href', this.swift);
            link.setAttribute('download', 'download');
            link.setAttribute('target', '_blank');
            link.click();
        },
        doSWIFT: function () {
            this.swift = '';
            this.$store.commit('wait', {state: true, name: 'Получение данных о сотрудниках'});
            this.$http
                .post(this.$apiold, {
                    task: 'swift-do',
                    org: this.org,
                    period: this.period,
                    params: this.params,
                    userdata: this.userdata
                })
                .then(response => {
                    if (!response.data.error) {
                        this.swift = response.data.result.swift;
                    }
                    this.$store.commit('wait', {state: false});
                    // Сообщения
                    this.$store.commit('alert', response.data.messages);
                });
        },

        getSelectedRows: function (list) {
            let count = 0;
            list.forEach(function (item) {
                if (Number(item.selected) == 1) {
                    count++;
                }
            });

            return count
        },

        getUserData: function () {
            this.userdata = [];
            this.swift = '';
            this.$store.commit('wait', {state: true, name: 'Получение данных о сотрудниках'});
            this.$http
                .post(this.$apiold, {
                    task: 'swift-get-userdata',
                    org: this.org,
                    period: this.period,
                    params: this.params
                })
                .then(response => {
                    if (!response.data.error) {
                        this.userdata = response.data.result.userdata;
                    }
                    this.$store.commit('wait', {state: false});
                    // Сообщения
                    this.$store.commit('alert', response.data.messages);
                });
        }
    },
    created() {
        this.getDataBank(this.org.bank_id)
            .then(response => {
                this.params.bank = response;
            })
    },
    computed: {
        ...mapGetters({
            user: 'user',
            org: 'org'
        })
    },
    watch: {
        period: {
            handler: function () {
                this.getUserData()
            },
            deep: true
        },
        'params.mode': {
            handler: function () {
                this.getUserData()

                switch (this.params.mode) {
                    case 'worker':
                        this.params.knp = '332'
                        break;
                    case 'opv':
                        this.params.knp = '010'
                        break;
                    case 'so':
                        this.params.knp = '012'
                        break;
                    case 'oosms':
                        this.params.knp = '121'
                        break;
                    case 'vosms':
                        this.params.knp = '122'
                        break;
                }
            },
            deep: true
        },
        'org.id': {
            handler: function () {
                this.getUserData()

                this.getDataBank(this.org.bank_id)
                    .then(response => {
                        this.params.bank = response;
                    })

            },
            deep: true
        },
        userdata: function () {
            if (this.userdata.length == 0) {
                this.disabled.doswift = true;
            } else {
                this.disabled.doswift = false;
            }
        },
        swift: function () {
            if (this.swift == '') {
                this.disabled.download = true;
                this.tooltip = 'Для того чтобы скачать сначала сформируйте SWIFT'
            } else {
                this.disabled.download = false;
                this.tooltip = 'Для того, чтобы скачать SWIFT кликните по этой кнопке правой кнопкой мыши, а потом выберите СОХРАНИТЬ КАК...'
            }
        }
    }
}
</script>


<style>

</style>
